module.exports = __webpack_public_path__ + "static/media/icon_7.9c7a17ec.svg";